import FetchMeta from "../../../../utilities/data/model/FetchMeta";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { View, Text } from "react-native-ui-lib";
import { formatDateToCalendar } from "../../../../utilities/date/format-date";

const getObserables = ({ fetchMeta }: { fetchMeta: FetchMeta }) => ({
  fetchMeta: fetchMeta.observe(),
});

interface ObservedLastSyncedProps
  extends ExtractedObservables<ReturnType<typeof getObserables>> {}

const ObservedLastSyncedRenderer = ({ fetchMeta }: ObservedLastSyncedProps) => {
  return (
    <View style={{ alignItems: "flex-end" }}>
      <Text style={{ opacity: 0.5, fontSize: 12 }}>Last synced</Text>
      <Text>{formatDateToCalendar(fetchMeta.lastFetch?.toString() || "")}</Text>
    </View>
  );
};

export const ObservedLastSynced = withObservables(
  ["fetchMeta"],
  getObserables
  // @ts-ignore
)(ObservedLastSyncedRenderer);
